module.exports = __webpack_public_path__ + "img/bg-magento-find-out@2x.a8bb7f38.webp";